import React from 'react';
import { useI18n } from '@/i18n';

const NotFoundPage: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-6 py-16">
      <div className="text-center text-black">
        <h1 className="text-[clamp(5rem,18vw,12rem)] font-black leading-none tracking-[-0.06em]">
          404
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-7 text-black sm:text-lg">
          {t('notFound.description')}
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
